import "@rails/request.js"
// Only the plugins driven by data attributes in the views or used by the components.
// Each of them wires up its data API as soon as it got imported.
import Alert from 'bootstrap/js/dist/alert'
import Collapse from 'bootstrap/js/dist/collapse'
import Dropdown from 'bootstrap/js/dist/dropdown'
import Modal from 'bootstrap/js/dist/modal'
import Offcanvas from 'bootstrap/js/dist/offcanvas'
import Tab from 'bootstrap/js/dist/tab'
import { createApp, defineAsyncComponent } from 'vue/dist/vue.esm-bundler';
import { createI18n } from 'vue-i18n'
import Rails from '@rails/ujs';
import ActionCableVue from "actioncable-vue";
import { messages } from '../modules/i18n-messages'
import { initColorMode } from '../modules/color-mode'
import { initSidebar } from '../modules/sidebar'
import { protectFromInterpolation } from '../modules/template-guard'

import ColorInput from '../components/color-input.vue'
import CopyLink from '../components/copy-link.vue'
import CustomAttributeOptions from '../components/custom-attribute-options.vue'
import CustomAttributeValues from '../components/custom-attribute-values.vue';
import EventVolunteerFinder from '../components/event-volunteer-finder.vue'
import Fullscreen from '../components/fullscreen.vue'
import Time from '../components/time.vue'
import VolunteerRemember from '../components/volunteer-remember.vue'
import VolunteerSubscription from '../components/volunteer-subscription.vue'
import autosize from 'autosize'

// Components which are only used on a few pages and pull in large dependencies
// (the timetable grid, SortableJS) are loaded on demand, so every other page doesn't have to.
const TimetableList = defineAsyncComponent(() => import('../components/timetable-list.vue'))
const TimetablePositions = defineAsyncComponent(() => import('../components/timetable-positions.vue'))
const TimetableVolunteers = defineAsyncComponent(() => import('../components/timetable-volunteers.vue'))
const KanbanDevisions = defineAsyncComponent(() => import('../components/kanban-divisions.vue'))
const CurrentShifts = defineAsyncComponent(() => import('../components/current-shifts.vue'))
const VolunteerStatistics = defineAsyncComponent(() => import('../components/volunteer-statistics.vue'))

window.bootstrap = { Alert, Collapse, Dropdown, Modal, Offcanvas, Tab }

const connectionUrl = document.querySelector('meta[name="action-cable-url"]')?.getAttribute('content');
const app = createApp().use(ActionCableVue, { connectionUrl: connectionUrl })

/* vue-i18n (https://github.com/intlify/vue-i18n-next) */
const i18n = createI18n({
  locale: document.documentElement.lang,
  fallbackLocale: 'en',
  messages,
})
app.use(i18n)

app.component('VueColorInput', ColorInput)
app.component('VueCopyLink', CopyLink)
app.component('VueCurrentShifts', CurrentShifts)
app.component('VueCustomAttributeOptions', CustomAttributeOptions)
app.component('VueCustomAttributeValues', CustomAttributeValues)
app.component('VueEventVolunteerFinder', EventVolunteerFinder)
app.component('VueFullscreen', Fullscreen)
app.component('VueTime', Time)
app.component('VueTimetableList', TimetableList)
app.component('VueTimetablePositions', TimetablePositions)
app.component('VueTimetableVolunteers', TimetableVolunteers)
app.component('VueKanbanDivisions', KanbanDevisions)
app.component('VueVolunteerRemember', VolunteerRemember)
app.component('VueVolunteerStatistics', VolunteerStatistics)
app.component('VueVolunteerSubscription', VolunteerSubscription)
protectFromInterpolation(document.querySelector('#app'))
app.mount('#app');

initSidebar();
initColorMode();

Rails.start();

autosize(document.querySelectorAll('textarea'));

const registerServiceWorker = async () => {
  if (navigator.serviceWorker) {
    try {
      await navigator.serviceWorker.register('/service-worker.js');
      console.log('Service worker registered!');
      return true;
    } catch (error) {
      console.error('Error registering service worker: ', error);
    }
  }
  return false;
};

document.addEventListener('DOMContentLoaded', () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timeZone) {
    const expires = new Date();
    expires.setMonth(expires.getMonth() + 1);
    document.cookie = `browser_time_zone=${timeZone}; path=/; expires=${expires.toUTCString()}; SameSite=Lax`;
  }
});